import { EBorrowerCitizenshipStatus } from '@/context/borrower';
import { selectIsNZ } from '@/context/display';
import { store } from '@/context/store';
import { LivingStatus } from '@/UserInput';
import { AddressState } from '@/UserInput/AddressState';
import { BirthDate } from '@/UserInput/BirthDate';
import { Email } from '@/UserInput/Email';
import { FirstName } from '@/UserInput/FirstName';
import { LastName } from '@/UserInput/LastName';
import { LicenseExpiry } from '@/UserInput/LicenseExpiry';
import { LicenseNumber } from '@/UserInput/LicenseNumber';
import { LicenseState } from '@/UserInput/LicenseState';
import { MiddleName } from '@/UserInput/MiddleName';
import { MobileNumber } from '@/UserInput/MobileNumber';
import { PostCode } from '@/UserInput/PostCode';
import { ResidencyStatus } from '@/UserInput/ResidencyStatus';
import { StreetName } from '@/UserInput/StreetName';
import { StreetNumber } from '@/UserInput/StreetNumber';
import { SuburbName } from '@/UserInput/SuburbName';
import { UnitNumber } from '@/UserInput/UnitNumber';
import { VisaExpiryDate } from '@/UserInput/VisaExpiryDate';
import { VisaNumber } from '@/UserInput/VisaNumber';

import { isBirthDateValid } from '../checkBirthDate';
import { isLicenseExpiryDateValid } from '../checkLicenseExpiryDate';
import { isVisaExpiryDateValid } from '../checkVisaExpiryDate';
import { isEmail } from '../isEmail';

export function getOcrFields(baseId, showErrors): JSX.Element[] {
    const fields: JSX.Element[] = [];
    const stateCall = store.getState();
    const firstName = stateCall.borrowerReducer.personalDetails.firstName;
    const lastName = stateCall.borrowerReducer.personalDetails.lastName;
    const middleName = stateCall.borrowerReducer.personalDetails.middleName;
    const email = stateCall.borrowerReducer.personalDetails.email;
    const ownershipType =
        stateCall.borrowerReducer.address.address[0].ownershipType;
    const mobileNumber = stateCall.borrowerReducer.personalDetails.mobilePhone;
    const licenseNumber =
        stateCall.borrowerReducer.personalDetails.licenseNumber;
    const licenseState = stateCall.borrowerReducer.personalDetails.licenseState;
    // const licenseVersionNumber =
    //     stateCall.borrowerReducer.personalDetails.licenseVersionNumber; // Optional for NZ
    const visaNumber = stateCall.borrowerReducer.personalDetails.visaNumber;
    const residencyStatus =
        stateCall.borrowerReducer.personalDetails.citizenshipStatus;

    const address = stateCall.borrowerReducer.address.address[0];
    const isNZ = selectIsNZ(stateCall);
    const { streetNumber, streetName, suburb, state, postcode, unitNumber } =
        address;

    if (residencyStatus === null || residencyStatus === undefined) {
        fields.push(
            <ResidencyStatus baseId={baseId} showErrors={showErrors} />
        );
    }
    if (ownershipType === null || ownershipType === undefined) {
        fields.push(<LivingStatus baseId={baseId} showErrors={showErrors} />);
    }
    if (firstName === '' || firstName === undefined) {
        fields.push(<FirstName baseId={baseId} showErrors={showErrors} />);
    }
    if (middleName === '' || middleName === undefined) {
        fields.push(<MiddleName baseId={baseId} showErrors={showErrors} />);
    }
    if (lastName === '' || lastName === undefined) {
        fields.push(<LastName baseId={baseId} showErrors={showErrors} />);
    }
    if (mobileNumber && (mobileNumber === '' || mobileNumber?.length < 10)) {
        fields.push(<MobileNumber baseId={baseId} showErrors={showErrors} />);
    }
    if (!isEmail(email)) {
        fields.push(<Email baseId={baseId} showErrors={showErrors} />);
    }
    if (
        residencyStatus === EBorrowerCitizenshipStatus.VISA_HOLDER &&
        !isNZ &&
        !isVisaExpiryDateValid()
    ) {
        fields.push(<VisaExpiryDate baseId={baseId} showErrors={showErrors} />);
    }
    if (
        residencyStatus === EBorrowerCitizenshipStatus.VISA_HOLDER &&
        !isNZ &&
        (visaNumber === undefined || visaNumber === 0)
    ) {
        fields.push(<VisaNumber baseId={baseId} showErrors={showErrors} />);
    }
    if (!isBirthDateValid()) {
        fields.push(<BirthDate baseId={baseId} showErrors={showErrors} />);
    }
    // Only require license expiry for AU users
    if (!isNZ && !isLicenseExpiryDateValid()) {
        fields.push(<LicenseExpiry baseId={baseId} showErrors={showErrors} />);
    }
    // Hide licence number when NZ, LicenseVersionNumber is optional for NZ
    if (isNZ) {
        // LicenseVersionNumber is optional for NZ - don't show in missing fields
    } else {
        if (licenseNumber === '' || licenseNumber === undefined) {
            fields.push(
                <LicenseNumber baseId={baseId} showErrors={showErrors} />
            );
        }
    }
    // Only require license state for AU users
    if (!isNZ && (licenseState === null || licenseState === undefined)) {
        fields.push(<LicenseState baseId={baseId} showErrors={showErrors} />);
    }
    if (unitNumber === '' || unitNumber === undefined) {
        if (streetNumber === '' || streetNumber === undefined) {
            fields.push(<UnitNumber baseId={baseId} showErrors={showErrors} />);
        }
    }
    if (streetNumber === '' || streetNumber === undefined) {
        fields.push(<StreetNumber baseId={baseId} showErrors={showErrors} />);
    }
    if (streetName === '' || streetName === undefined) {
        fields.push(<StreetName baseId={baseId} showErrors={showErrors} />);
    }
    if (suburb === '' || suburb === undefined) {
        fields.push(<SuburbName baseId={baseId} showErrors={showErrors} />);
    }
    if (state === null || state === undefined) {
        fields.push(<AddressState baseId={baseId} showErrors={showErrors} />);
    }
    if (
        postcode === '' ||
        postcode === undefined ||
        postcode.toString().length < 4
    ) {
        fields.push(<PostCode baseId={baseId} showErrors={showErrors} />);
    }
    return fields;
}
